import { render, staticRenderFns } from "./Tactical.vue?vue&type=template&id=25353591&"
import script from "./Tactical.vue?vue&type=script&lang=js&"
export * from "./Tactical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports